<template>
  <div style="margin-bottom: 50px;">
    <div class="mb-base">
      <vx-card class="org-card">
        <vs-input 
          class="w-full board-user-search"
          size="large"
          placeholder="Search for people based on their skills, personality traits, location, etc."
          v-model="searchQuery"
        />
      </vx-card>
    </div>
    <div v-if="paginatedBoardUsers.length" class="vx-row">
      <div
        v-for="(i, index) in paginatedBoardUsers"
        :key="index"
        class="vx-col w-full lg:w-1/3 xl:w-1/3 mb-base"
      >
        <user-card
          :boardUserData="i"
          @editBoardUser="editBoardUserPopup(i.userData.email)"
          @deactivateBoardUser="deactivateBoardUser"
          @resendBoardInvitationLink="resendBoardInvitationLink"
          :isAlexInstalled="isAlexInstalled"
        />
      </div>
      <vs-pagination 
        :total="Math.ceil((Array.isArray(currentBoardUsers) ? currentBoardUsers.length : 0) / 30)" 
        v-model="currentPage">
      </vs-pagination>
    </div>
  </div>
</template>

<script>
import constants from "@/constants";
import organizationConfig from "@/assets/data/organization-config.js";
import UserCard from "./UserCard.vue";
import _ from 'lodash';

export default {
  props: {
    // currentBoardUsers: {
    //     type: Array,
    //     required: true
    // },
    isAlexInstalled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
      constants,
      organizationConfig,
      currentPage: 1
    };
  },
  computed: {
    currentBoardUsers() {
      return this.$store.state.boards.currentBoardUsers;
    },
    paginatedBoardUsers() {
      // Safely check if it's an array before slicing
      const users = Array.isArray(this.currentBoardUsers) ? this.currentBoardUsers : [];
      return users.slice(30*(this.currentPage-1), 30*this.currentPage);
    },
    personalityData() {
        return this.organizationConfig['default'].personalityTraits['en'];   
    },
    currentBoard() {
      return this.$store.state.boards.currentBoard;
    },
  },
  watch: {
    searchQuery() {
      setTimeout(this.searchBoardUsers, 500);
    },
    currentBoard(newVal) {
      if(newVal && newVal._id) {
        // fetch BoardUserProfileAnalytics
        this.$store.dispatch("boards/fetchBoardUserProfileAnalytics", newVal._id);
      }
    },
  },
  components: { UserCard },
  methods: {
    editBoardUserPopup(email) {
      this.$emit("editBoardUser", email);
    },
    deactivateBoardUser(boardUserObj) {
      this.$emit("deactivateBoardUser", boardUserObj);
    },
    resendBoardInvitationLink(email) {
      this.$emit("resendBoardInvitationLink", email);
    },
    searchBoardUsers() {
      if(this.currentBoard._id) {
        if(this.searchQuery && this.searchQuery.length) {
          this.$store
          .dispatch("boards/searchBoardUsers", {
            boardId: this.currentBoard._id,
            searchString: this.searchQuery
          }).catch((err) => {
            throw err;
          });
        } else {
          this.$store
          .dispatch("boards/fetchAllUsersInBoardV2", this.currentBoard._id)
          .catch((err) => {
            throw err;
          });
        } 
      }
    }
  },
  created() {
    if(this.currentBoard && this.currentBoard._id) {
      // fetch BoardUserProfileAnalytics
      this.$store.dispatch("boards/fetchBoardUserProfileAnalytics", this.currentBoard._id);
    }
  }
};
</script>

<style scoped>
/* .board-user-search {
  font-size: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
[contenteditable][placeholder]:empty:before {
  content: attr(placeholder);
  position: absolute;
  color: gray;
  background-color: transparent;
  font-size: 15px;
} */

.board-user-search >>> .vs-con-input .vs-input--input {
  box-shadow: none!important;
}
</style>